import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { useLocalizedHref } from "@/libraries/web-framework";

export interface BreadcrumbsProps {
    links: {
        name: string;
        path: string;
    }[];
}

export interface BreadcrumbProps {
    link: string;
    name: string;
}

const breadcrumbLink = css({
    ":hover": {
        textDecoration: "underline"
    }
});

const breadcrumbsUnorderedList = css({
    display: "flex",
    listStyle: "none",
    padding: "0px"
});

const breadcrumbsFirstItem = css({
    "color": "#253858",
    "fontSize": "14px",
    "::after": {
        content: "/",
        display: "inline-block",
        color: "#7a869a",
        margin: "0px 4px 0px 4px"
    },
    [media.above.sm]: {
        fontSize: "16px"
    }
});

const breadcrumbsInnerListItem = css({
    display: "none",
    [media.above.sm]: {
        "display": "inline",
        "color": "#253858",
        "::after": {
            content: "/",
            display: "inline-block",
            color: "#7a869a",
            margin: "0px 4px 0px 4px"
        }
    }
});

const breadcrumbsLastItem = css({
    color: "#7a869a",
    fontSize: "14px",
    [media.above.sm]: {
        fontSize: "16px"
    }
});

const Breadcrumb = ({ link, name }: BreadcrumbProps) => {
    return (
        <a
            css={breadcrumbLink}
            data-event="clicked"
            data-event-component="linkButton"
            data-event-container="micrositeNav"
            data-product-key="jiraSoftware"
            href={useLocalizedHref(link)}
        >
            {name}
        </a>
    );
};

export const Breadcrumbs = ({ links }: BreadcrumbsProps) => {
    return (
        <>
            <ul css={breadcrumbsUnorderedList}>
                {links.map((link, index) => {
                    if (index === 0) {
                        return (
                            <li css={breadcrumbsFirstItem} key={index}>
                                <Breadcrumb name={link.name} link={link.path} />
                            </li>
                        );
                    } else if (index + 1 === links.length) {
                        return (
                            <li css={breadcrumbsLastItem} key={index}>
                                <Breadcrumb name={link.name} link={link.path} />
                            </li>
                        );
                    } else {
                        return (
                            <li css={breadcrumbsInnerListItem} key={index}>
                                <Breadcrumb name={link.name} link={link.path} />
                            </li>
                        );
                    }
                })}
            </ul>
        </>
    );
};
